(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["holo-bulk"]) return;
  try {
    
(() => {
  const init = () => document.querySelectorAll('[data-holo-root]').forEach(root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const rows = [...root.querySelectorAll('[data-rate]')];
    const money = cents => new Intl.NumberFormat('en-US', {style:'currency',currency:'USD'}).format(cents/100);
    const select = s => root.querySelector(s);
    const setText = (s,t) => {const e=select(s);if(e)e.textContent=t;};
    const form = select('#HoloSubmission');

    const cardDialog = select('[data-card-dialog]');
    if (cardDialog) {
      let opener;
      root.querySelectorAll('[data-card-open]').forEach(button => button.addEventListener('click', () => {
        opener = button;
        const info = button.dataset, src = button.querySelector('img').src;
        const large = select('[data-card-large]'), zoom = select('[data-card-zoom]');
        large.src = src; large.alt = info.cardName;
        zoom.src = src;
        setText('[data-card-heading]', info.cardTitle);
        setText('[data-card-dialog] [data-card-name]', info.cardName);
        setText('[data-card-dialog] [data-card-note]', info.cardNote);
        setText('[data-card-dialog] [data-card-feature]', info.cardFeature || '');
        const marker = select('[data-card-marker]');
        const photoOnly = info.cardDetail === 'photo';
        marker.hidden = photoOnly;
        zoom.parentElement.hidden = photoOnly;
        select('[data-card-dialog] [data-card-feature]').hidden = photoOnly;
        select('[data-card-source]').hidden = info.cardCredit === 'none';
        marker.style.width = (info.cardMarkWidth || '10') + '%';
        marker.style.height = info.cardMarkHeight ? info.cardMarkHeight + '%' : '';
        marker.style.aspectRatio = info.cardMarkHeight ? 'auto' : '1';
        marker.style.left = info.cardX + '%'; marker.style.top = info.cardY + '%';
        zoom.style.left = (110 - Number(info.cardX) * 6) + 'px';
        zoom.style.top = (48 - Number(info.cardY) * 8.25) + 'px';
        cardDialog.showModal();
      }));
      select('[data-card-close]').addEventListener('click', () => cardDialog.close());
      cardDialog.addEventListener('click', event => {
        if (event.target !== cardDialog) return;
        const rect = cardDialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) cardDialog.close();
      });
      cardDialog.addEventListener('close', () => opener?.focus());
    }
    const ref = 'HU-' + new Date().toISOString().slice(0,10).replaceAll('-','') + '-' + Array.from(crypto.getRandomValues(new Uint8Array(8)), n => n.toString(16).padStart(2,'0')).join('').toUpperCase();
    setText('[data-reference]',ref);
    if(select('[data-ref-field]')) select('[data-ref-field]').value=ref;
    try {const saved=sessionStorage.getItem('holo-submission-ref');if(saved)setText('[data-success-ref]',saved);}catch{}
    try {
      if(!form?.querySelector('[data-ref-field]'))sessionStorage.removeItem('holo-quantities');
      else {const saved=JSON.parse(sessionStorage.getItem('holo-quantities')||'{}');rows.forEach(row=>{const input=row.querySelector('input');if(typeof saved[input.dataset.label]==='string')input.value=saved[input.dataset.label];});}
    }catch{}
    let total=0,count=0,valid=true;
    const update = () => {
      try{sessionStorage.setItem('holo-quantities',JSON.stringify(Object.fromEntries(rows.map(row=>{const input=row.querySelector('input');return [input.dataset.label,input.value];}))));}catch{}
      total=0;count=0;valid=true;let categories=0;const details=[];
      rows.forEach(row=>{
        const input=row.querySelector('[data-quantity]');
        const raw=input.value.trim();
        const n=raw===''?0:Number(raw);
        const rate=Number(row.dataset.rate);
        const ok=Number.isSafeInteger(n)&&n>=0&&n<=10000000&&Number.isSafeInteger(rate)&&rate>=0&&rate<=1000000&&!input.validity.badInput;
        input.setCustomValidity(ok?'':'Enter a whole number from 0 to 10,000,000.');
        valid=valid&&ok;
        const qty=ok?n:0, subtotal=qty*rate;
        row.querySelector('.row-total').textContent=ok?money(subtotal):'—';
        total+=subtotal;count+=qty;
        if(qty>0){categories++;details.push(`${input.dataset.label}: ${qty.toLocaleString('en-US')} × ${money(rate)} = ${money(subtotal)}`);}
      });
      if(!Number.isSafeInteger(total)){valid=false;}
      setText('[data-total]',valid?money(total):'Check quantities');
      setText('[data-count]',count.toLocaleString('en-US'));setText('[data-categories]',categories);
      setText('[data-form-total]',valid?money(total):'Check quantities');setText('[data-form-count]',count.toLocaleString('en-US'));
      const list=select('[data-breakdown]');if(list){list.replaceChildren();(details.length?details:['No quantities entered yet.']).forEach(t=>{const li=document.createElement('li');li.textContent=t;list.append(li);});}
      if(select('[data-total-field]'))select('[data-total-field]').value=valid?money(total):'INVALID';
      if(select('[data-details-field]'))select('[data-details-field]').value=details.join('\n');
    };
    rows.forEach(r=>r.querySelector('input').addEventListener('input',update));
    select('[data-reset]')?.addEventListener('click',()=>{rows.forEach(r=>r.querySelector('input').value='');update();});
    form?.addEventListener('submit',event=>{
      if(form.querySelector('button[type=submit]')?.disabled){event.preventDefault();setText('[data-form-error]','Submissions are not open yet.');return;}
      update();
      if(!valid||count===0){event.preventDefault();setText('[data-form-error]',valid?'Enter at least one card in the calculator before submitting.':'Correct the highlighted quantities in the calculator.');select('#calculator').scrollIntoView();rows.find(r=>!r.querySelector('input').checkValidity())?.querySelector('input').reportValidity();return;}
      if(select('[data-date-field]'))select('[data-date-field]').value=new Date().toISOString();
      try{sessionStorage.setItem('holo-submission-ref',ref);}catch{}
    });
    update();
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
